import { render, staticRenderFns } from "./fvLoading.vue?vue&type=template&id=cf01a20e&lang=pug&"
var script = {}
import style0 from "./fvLoading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "fvLoading.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/fvLoading.vue
// module id = 182
// module chunks = 0 1